import axios from "axios";
import idAuthHeader from "../auth-header";

const API_URL = process.env.REACT_APP_API_URL + "api/accounts/";

class AccountService {
  async getAccountsForEMRAsync() {
    return axios.get(API_URL + "emr", { headers: await idAuthHeader() });
  }

  async getAccounts() {
    return axios.get(API_URL + "coreschedule", {
      headers: await idAuthHeader(),
    });
  }
}

const accountService = new AccountService();
export default accountService;
